import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-right-header-yonghuguanli",
  "use": "icon-right-header-yonghuguanli-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right-header-yonghuguanli\"><path d=\"M795.52 327.68A263.68 263.68 0 1 0 384 545.28a405.12 405.12 0 0 0-256 376.96 36.48 36.48 0 1 0 72.96 0 331.52 331.52 0 0 1 331.52-331.52 264.32 264.32 0 0 0 263.68-263.68z m-263.68 192a192 192 0 1 1 192-192 192 192 0 0 1-192 192zM665.6 662.4a39.68 39.68 0 0 0 39.04 39.04h151.68a39.04 39.04 0 1 0 0-78.08H704a39.68 39.68 0 0 0-38.4 37.76z m192 83.2H645.12a39.04 39.04 0 0 0 0 78.08h211.84a39.04 39.04 0 1 0 0-78.08z m0 122.88h-256a39.04 39.04 0 0 0 0 78.08h256a39.04 39.04 0 0 0 0-78.08z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/right-header-yonghuguanli.svg
// module id = 5H29
// module chunks = 8